enum InteractiveStatus {
  Waiting = 'waiting',
  Interactive = 'interactive',
  Success = 'success',
  Fail = 'fail',
  FailedErrorCode = 'failedErrorCode',
}

export default InteractiveStatus
